<div class="crown-tag" [ngClass]="'crown-tag--'+bgColor">
  <img [src]="'/assets/icons/'+icon" alt="">
  {{ "common."+title | translate }}
</div>